/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_Digest_OffInputs */

const en_fw_notify_digest_off = /** @type {(inputs: Fw_Notify_Digest_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off`)
};

const id_fw_notify_digest_off = /** @type {(inputs: Fw_Notify_Digest_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mati`)
};

/**
* | output |
* | --- |
* | "Off" |
*
* @param {Fw_Notify_Digest_OffInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_digest_off = /** @type {((inputs?: Fw_Notify_Digest_OffInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_Digest_OffInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_digest_off(inputs)
	return en_fw_notify_digest_off(inputs)
});